export const EmpresaEntity = {
    id: null,
    ruc: '',
    razonSocial: '',
    nombreComercial: '',
    departamento: '',
    provincia: '',
    distrito: '',
    ubigeo: '',
    direccion: '',
    telefono: '',
    email: '',
    enabled: true
};